import { Api } from "@/plugins/api"

export const getContextWithToken = (token) => {
  return Api.get("/extranet/auth?token=" + token)
}

export const authenticate = (login, password) => {
  return Api.post("/authenticator/auth", {
    login: login,
    password: password
  })
}